exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".routerLink a:hover{text-decoration:none}.allLink{position:relative}.allLink a:hover{text-decoration:none}.pageHeaderContainer h1{margin:0}.filter_languagesContainer{overflow-y:auto;overflow-x:hidden;max-height:calc(100% - 45px)}.filter_languagesContainer_portrait{overflow-y:auto;overflow-x:hidden;max-height:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--3-1!../node_modules/postcss-loader/lib!../node_modules/sass-loader/lib/loader.js!./assets/scss/Filter.scss
// module id = 375
// module chunks = 0